export enum SecurityDisplayLevel {
  None = "Anonymous",
  Simple = "Listed Users",
  AzureAd = "Azure Entra Login"
}

export enum ButtonLocationDisplay {
  Header = "Header",
  DataCapture = "DataCapture"
}